/**
 * Applies display overrides to status labels.
 * Currently: "Fail" displays as "Compliance Required"
 */
export const applyStatusLabelOverrides = (translatedLabel: string): string => {
    return translatedLabel === 'Fail' ? 'Compliance Required' : translatedLabel;
};
